// extracted by mini-css-extract-plugin
export var avatar = "_rc-3";
export var avatarContainer = "_rc-2";
export var avatarSpacer = "_rc-5";
export var avatarSpacerContainer = "_rc-4";
export var avatarStackContainer = "_rc-1";
export var bubble = "_rc-0";
export var remainderBubble = "_rc-6";